import classNames from 'classnames'
import { arrayOf, bool, shape } from 'prop-types'

import SliderHorizontal from 'views/components/organisms/SliderHorizontal'
import { MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER } from 'views/consts'
import {
  shouldShowBuyButton,
  showBuyButtonForAllCSWExperiment,
} from 'views/containers/crosssell/CrosssellSliderHorizontal/utils'
import { shouldRenderRedPointsBadge } from 'views/containers/crosssell/CrosssellSliderTop/helpers'
import withMountPoints from 'views/enhancers/withMountPoints'
import { mountPointsType } from 'views/utils/propTypes'
import ProductType from 'views/utils/propTypes/api/Product_v1'

import HorizontalSliderItem from './ProductSliderItem'

import 'shared/experiments/components/newCsw/CrosssellSliderTop.scss'
import './CrosssellSliderTop.scss'

const SliderComponent = ({
  items,
  mountPoints,
  noSlider,
  asTopSlider,
  className,
  sparse,
  goToProductButton,
  publicRuntimeConfig: {
    pageProperties: { experiments },
  },
  widgets,
  redirectToCart,
  ...rest
}) => {
  let products = items
  let itemsForLazyLoad
  if (noSlider && items.length > MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER) {
    products = items.slice(0, MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER)
    itemsForLazyLoad = items.slice(MAX_VISIBLE_ITEM_FOR_MULTILINE_SLIDER)
  }

  const hasRedPoints = products.some(shouldRenderRedPointsBadge)

  let headersProps = {}
  if (asTopSlider) {
    headersProps = {
      headerTag: 'h3',
      itemHeaderTag: 'h3',
    }
  }

  const showBuyButton =
    showBuyButtonForAllCSWExperiment(experiments) ||
    shouldShowBuyButton(rest.wid, widgets)

  return (
    <SliderHorizontal
      {...rest}
      headerTag={headersProps.headerTag}
      headerClassName={classNames('l-flex--vertical l-flex--start', {
        'u-padding-x-small--bottom': !sparse,
        'u-padding--bottom': sparse,
      })}
      noSlider={noSlider}
      itemsForLazyLoad={itemsForLazyLoad}
      className={classNames(className, {
        'o-SliderHorizontalTop--hasRedPoints': hasRedPoints,
      })}
      items={products.map((product, idx) => (
        <HorizontalSliderItem
          asTopSlider={asTopSlider}
          goToProductButton={goToProductButton}
          headerTag={headersProps.itemHeaderTag}
          index={idx}
          key={product.id}
          noSlider={noSlider}
          product={product}
          redirectToCart={redirectToCart}
          showBuyButton={showBuyButton}
          sparse={sparse}
          srcHeight={130}
          wid={rest.wid}
          thumbnail
        />
      ))}
    />
  )
}

SliderComponent.propTypes = {
  ...SliderHorizontal.propTypes,
  mountPoints: mountPointsType.isRequired,
  items: arrayOf(shape(ProductType)),
  sparse: bool,
  goToProductButton: bool,
  widgets: shape({}),
  publicRuntimeConfig: shape({
    pageProperties: shape({
      experiments: arrayOf(shape({}).isRequired).isRequired,
    }).isRequired,
  }).isRequired,
  redirectToCart: bool,
}

SliderComponent.defaultProps = {
  ...SliderHorizontal.defaultProps,
  items: null,
  sparse: false,
  goToProductButton: false,
  widgets: null,
  redirectToCart: false,
}

export default withMountPoints(SliderComponent)
